import { selectOptionsCustomTrait } from '../customTraits';
import { basicCommands } from './basicCommands';
import { basicExtendedBlocks } from './basicExtendedBlocks';
import { basicPanels } from './basicPanels';
import { basicStyles } from './basicStyles';
import { extendedVideo } from './extendedVideo';

export const basicPlugin = (editor, config) => {
  basicCommands(editor, config);
  basicPanels(editor);
  basicStyles(editor);
  basicExtendedBlocks(editor);
  selectOptionsCustomTrait(editor);
  extendedVideo(editor);
};
